import { type CloudFlowNodeType } from "@doitintl/cmp-models";
import { Stack } from "@mui/material";

import AWSPermissionForm from "../../ApiActionParametersForm/AWSPermissionForm";
import GCPPermissionForm from "../../ApiActionParametersForm/GCPPermissionForm";
import { useNodeConfigurationContext } from "../NodeConfigurationContext";

const PermissionsTab = () => {
  const { nodeConfig } = useNodeConfigurationContext<CloudFlowNodeType.ACTION>();

  return (
    <Stack spacing={2} p={2} alignItems="flex-start">
      {nodeConfig.parameters?.provider === "AWS" && <AWSPermissionForm />}
      {nodeConfig.parameters?.provider === "GCP" && <GCPPermissionForm />}
    </Stack>
  );
};

export default PermissionsTab;
